import { render, staticRenderFns } from "./Chart5.vue?vue&type=template&id=2bf7541d&scoped=true"
import script from "./Chart5.vue?vue&type=script&lang=js"
export * from "./Chart5.vue?vue&type=script&lang=js"
import style0 from "./Chart5.vue?vue&type=style&index=0&id=2bf7541d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7541d",
  null
  
)

export default component.exports